/* 09 · Adoptez le look MILA (Shopify : assets/obaia-section-look.js)
   - Point produit : placé sur le sac quelle que soit la taille de l’écran (position en proportion de la photo, 0 → 1)
   - Animation : photo de bas en haut (1 500 ms) ; 0,75 s après, titre ligne par ligne, vignette, lien ;
     une fois la photo dévoilée, le point apparaît (0,6 → 1, 600 ms) puis son halo pulse toutes les 2,4 s. */
OBAIA.section('look', {
  init: function (root) {
    OBAIA.$$('[data-section="look"]', root).forEach(function (sec) {
      var media = OBAIA.$('.look__media', sec), img = OBAIA.$('img', media), point = OBAIA.$('[data-hotspot]', media);
      if (!img || !point) return;
      function place() {
        var W = +img.getAttribute('width'), H = +img.getAttribute('height');
        var m = OBAIA.isMobile() && point.getAttribute('data-x-mobile');
        var x = +point.getAttribute(m ? 'data-x-mobile' : 'data-x'), y = +point.getAttribute(m ? 'data-y-mobile' : 'data-y');
        var cw = media.clientWidth, ch = media.clientHeight;
        var s = Math.max(cw / W, ch / H);                 // object-fit: cover, centré
        point.style.left = (cw / 2 + (x - 0.5) * W * s) + 'px';
        point.style.top = (ch / 2 + (y - 0.5) * H * s) + 'px';
      }
      place();
      window.addEventListener('resize', place);
    });
  },
  anim: function (fx) {
    var $ = OBAIA.$;
    OBAIA.$$('[data-section="look"]').forEach(function (sec) {
      var media = $('.look__media', sec), point = $('[data-hotspot]', sec);
      var title = $('.look__title', sec), prod = $('.look__produit', sec), lien = $('.lien', sec);
      function photo(tl) {
        var dur = fx.reveal(tl, media, 0);
        if (point) tl.fromTo(point, { opacity: 0, scale: 0.6 }, { opacity: 1, scale: 1, duration: 0.6, ease: fx.EASE, clearProps: 'transform',
          onComplete: function () { point.classList.add('is-pulsing'); } }, dur);
        return dur;
      }
      function texte(tl, t) {
        var d = fx.lines(tl, title, t);
        fx.appear(tl, prod, t + d + 0.1);
        fx.appear(tl, lien, t + d + 0.1 + fx.STEP);
      }
      if (OBAIA.isMobile()) {
        fx.when(media, function (tl) { photo(tl); });
        fx.when(title, function (tl) { texte(tl, 0.2); });
      } else {
        fx.when(media, function (tl) { photo(tl); texte(tl, 0.75 * fx.K); });
      }
    });
  }
});
